import Model from '@ember-data/model';
import attr from 'ember-data/attr';
import { or } from '@ember/object/computed';
import { belongsTo } from 'ember-data/relationships';
import PlanModel from 'cio/models/plan';

export const DEFAULT_BASIC_CUSTOMER_COUNT = 8000;
export const DEFAULT_BASIC_METERED_RATE = 0.008;
export const DEFAULT_BASIC_PLAN_PRICE = 15000;

export default class BillingInfoModel extends Model {
  @attr('boolean') activeSubscription!: boolean;
  @attr('boolean') active!: boolean;
  @attr('boolean') basic!: boolean;
  @attr('boolean') basicTrial!: boolean;
  @attr('boolean') cancelled!: boolean;
  @attr('boolean') overdue!: boolean;
  @attr('boolean') hasOverage!: boolean;
  @attr('boolean') newPricing!: boolean;
  @attr('boolean') premium!: boolean;
  @attr('boolean') premiumTrial!: boolean;
  @attr('boolean') lumpSum!: boolean;
  @attr('boolean') upsellToPremium!: boolean;
  @attr('boolean') trialSuspended!: boolean;
  @attr('boolean') showSignupForms!: boolean;
  @attr('number') estimatedInvoiceCost!: number;
  @attr('string') startupProgram!: string;
  @belongsTo('plan', { async: true, inverse: null }) pinnedPlan!: PlanModel;
  @attr('string') pinnedCouponCode!: string;
  @attr('string') setupIntentClientSecret!: string;
  @or('premiumTrial', 'basicTrial') trial!: boolean;
  @attr('boolean') cancellable!: boolean;
  @attr('boolean') canRetryPayment!: boolean;
  @attr('number') pinnedStartDate!: number;
  @attr('number') objectOverageAdjustment!: number;

  @attr() billingEstimates!: Record<string, number>;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'billing-info': BillingInfoModel;
  }
}
